import { InputComponent } from "components/components/Component";
import { SimpleInputBaseDefinition, InputBaseComponent } from "components/input/baseInputDefinition";
import { OrginalValue } from "components/input/baseHTMLElementInput";
import { Tooltip } from "components/components/tooltip/tooltip";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { OptionIterator } from "components/input/select/OptionIterator";
import $ from "jquery";
import { isOption, Optgroup, Option } from "components/input/select/options";
import template from "./checkMultiselect.hbs";
import "./checkMultiselect.scss";
import optionsTemplate from "./checkMultiselectOption.hbs";

export class CheckMultiselectInput
    extends InputBaseComponent<CheckMultiselectInputDefinition>
    implements InputComponent {

    public readonly componentType: string = "checkMultiselectInput";

    private definitionOptions: Option[];

    private _initialValue: OrginalValue = new OrginalValue();
    private _input: HTMLInputElement[];
    private _visited: boolean = false;

    constructor(schema: CheckMultiselectInputDefinition) {
        super(schema);
        if (this.definition.options != null) {
            this.definitionOptions = OptionIterator.filterFlat(this.definition.options, isOption);
        }
    }

    public render(): Element {
        this.renderTemplate();
        this.bindEvents();

        ComponentActionHelper.register(this);
        Tooltip.bindElement(this.view);
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private click_listener = (evt) => {
        fireDataChangedEvent(this, this.view, this.getValue());
    }

    private focus_listener = (evt) => {
        this._visited = true;
        evt.preventDefault();
    }

    private bindEvents(): void {

        this._input = Array.from(this.view.querySelectorAll("input"));

        this._input.forEach(input => {
            input.removeEventListener("click", this.click_listener);
            input.addEventListener("click", this.click_listener);

            input.removeEventListener("focus", this.focus_listener);
            input.addEventListener("focus", this.focus_listener);
        });
    }

    public getValue(): string[] {
        let values = [];
        $(this.view).find("input:checked").each((i, element) => {
            let valueString = $(element).val();
            // find the values in the options to return them with the correct type (number or string)

            // Yes, I know that we are not checking types. We want to compare string and number.
            // tslint:disable-next-line triple-equals
            let value = this.definitionOptions.find((o) => o.value == valueString);

            values.push(value.value);

        });
        return values;
    }

    public value(v: string[]) {
        $(this.view).find("input").prop("checked", false);
        if (v != null) {
            for (let value of v) {
                $(this.view).find("input[value='" + value + "']").prop("checked", true);
            }
        }
    }

    public setReadOnly(ro: boolean) {
        this._input.forEach(i => i.disabled = ro);
    }

    public setRequired(required: boolean) {
        const label = this.view.querySelector("label");
        if (label == null) {
            return;
        }
        if (required) {
            label.classList.add("is-required");
        } else {
            label.classList.remove("is-required");
        }
    }

    public setValidationStatus(valid: boolean, message?: string) {
        if (valid) {
            $(this.view).find(".c-check-multiselect__options").removeClass("is-invalid");
            $(this.view).removeAttr("data-tip");
        } else {
            $(this.view).find(".c-check-multiselect__options").addClass("is-invalid");
            $(this.view).attr("data-tip", message);
        }
    }

    public addOptions(options: Option[]): void {

        if (options == null) {
            return;
        }
        if (this.definitionOptions == null) {
            this.definitionOptions = [];
        }
        this.definitionOptions = this.definitionOptions.concat(options);

        let div = $(this.view).find(".c-check-multiselect__options");
        for (let option of options) {
            //Copy obj for add id´s
            const optionShallowCopy: any = { ...option };
            optionShallowCopy.id = this.definition.id;
            let templated = $(optionsTemplate(optionShallowCopy));
            templated.appendTo(div as JQuery<HTMLElement>);
        }

        this.bindEvents();
    }

}

export interface CheckMultiselectInputDefinition extends SimpleInputBaseDefinition {
    options?: Array<Option | Optgroup>;
}
